import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface ITenantStatistic extends IBaseEntity {
    id?: number;
    tenantId: number;
    tenantName: string;
    customerCount: number;
    driverCount: number;
    trailerCount: number;
    vehicleCount: number;
    invoiceCount: number;
    preInvoiceCount: number;
    erpUserCount: number;
    createdAt: string;
}

export class TenantStatistic extends BaseEntity implements ITenantStatistic {
    public id: number;
    public tenantId: number;
    public tenantName: string;
    public customerCount: number;
    public driverCount: number;
    public trailerCount: number;
    public vehicleCount: number;
    public invoiceCount: number;
    public preInvoiceCount: number;
    public erpUserCount: number;
    public createdAt: string;

    constructor(tenantStatistic?) {
        super();
        if (tenantStatistic) {
            this.id = tenantStatistic.id;
            this.tenantId = tenantStatistic.tenantId;
            this.tenantName = tenantStatistic.tenantName;
            this.customerCount = tenantStatistic.customerCount;
            this.driverCount = tenantStatistic.driverCount;
            this.trailerCount = tenantStatistic.trailerCount;
            this.vehicleCount = tenantStatistic.vehicleCount;
            this.invoiceCount = tenantStatistic.invoiceCount;
            this.preInvoiceCount = tenantStatistic.preInvoiceCount;
            this.erpUserCount = tenantStatistic.erpUserCount;
            this.createdAt = tenantStatistic.createdAt;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): TenantStatistic {
        return new TenantStatistic(this);
    }
}
